import { Popup, SpinLoading } from "antd-mobile";
import React, { useContext, useEffect, useState } from "react";
import PsContext from "../../context";
import { _UpcomingDayOrder } from "../../models/lessonPlans";
import {
  momentDate,
  MuiModalWindow,
  timeTableDayFromNumber,
  upperCase,
} from "../../utils";
import TodayTimeTable from "../todayTimeTable";
import UpcomingTimetableModal from "./upcomingTimetableModal";
import { Card } from "react-bootstrap";

const UpcomingTimeTable = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [errorData, setErrorData] = useState(null);
  const [showTimeTable, setShowTimeTable] = useState(false);

  let dayOrderInDayName = context.settingValue(
    "attendance_dayorder_as_day_name"
  );

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    setDataList([]);
    setErrorData(null);
    _UpcomingDayOrder().then((res) => {
      if (res.status == "1") setDataList(res.data);
      else setErrorData(res.message || "Day order not available");
      setLoader(false);
    });
  };

  return (
    <>
      <Card>
        <Card.Header className="card-header-bg text-uppercase">
          <span className="fw-bold">Upcoming Time Table</span>
          <span className="bg-theme px-2 text-white rounded fw-bold float-end">
            {dataList && dataList.day_order_value && (
              <>
                {dataList.day_order_text
                  ? upperCase(dataList.day_order_text)
                  : timeTableDayFromNumber(
                      dataList.day_order_value,
                      dayOrderInDayName
                    )}
              </>
            )}
          </span>
        </Card.Header>
        <Card.Body>
          {loader && (
            <center>
              <SpinLoading />
            </center>
          )}
          {dataList && dataList.day_order_date && (
            <>
              <span className="fw-bold">
                {momentDate(dataList.day_order_date, "DD MMM YYYY")}
              </span>
              <span
                className="float-end cursor-pointer theme-text"
                onClick={(e) => setShowTimeTable(true)}
              >
                View <i className="ms-3 fa-solid fa-arrow-right"></i>
              </span>
            </>
          )}
          {errorData && errorData.length > 4 && (
            <center className="text-danger py-2 fw-bold">{errorData}</center>
          )}
        </Card.Body>
      </Card>

      <MuiModalWindow
        title="Upcoming Time Table"
        open={showTimeTable}
        onClose={(e) => setShowTimeTable(false)}
      >
        <div className="container-sm py-md-3">
          <TodayTimeTable
            timeTableDate={dataList.day_order_date}
            upComing={true}
            titleText=" "
          />
        </div>
      </MuiModalWindow>
    </>
  );
};

export default UpcomingTimeTable;
